<template>
  <v-card>
    <v-card>
      <v-card-text>
        <v-card-title>
          <v-flex xs2 class="mr-4">
            <v-btn
              round
              color="success"
              class="white--text mb-3"
              @click="createNewMaterial"
            >
              <v-icon dark>add</v-icon>
              Crear nuevo material
            </v-btn>
          </v-flex>

          <v-flex xs3>
            <v-btn
              round
              color="success"
              class="white--text mb-3"
              @click="verCargaFactores"
            >
              <v-icon>attach_file</v-icon>
              Carga masiva materiales</v-btn
            >
            <v-space />
          </v-flex>

          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar..."
            single-line
            hide-details
            @change="getAllMateriales()"
            @keypress="getAllMateriales()"
            @keyup="getAllMateriales()"
            clearable
          ></v-text-field>
        </v-card-title>
      </v-card-text>
    </v-card>
    <br />
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <confirm ref="confirm"></confirm>
    <v-dialog
      v-model="dialogUpload"
      max-width="1100px"
      @input="(v) => v || verCargaFactores()"
    >
      <v-card>
        <v-card-title>
          <h3 class="mb-0">Cargar Masiva Materiales</h3>
        </v-card-title>
        <v-card-text>
          <v-flex sm10>
            <v-btn
              round
              color="success"
              class="white--text mb-3"
              @click="getMaterialesExcel"
            >
              <v-icon>attach_file</v-icon>
              Descargar Archivo Carga</v-btn
            >
          </v-flex>
          <v-flex sm10>
            <v-text-field
              label="Adjuntar Archivo"
              @click="pickFile"
              v-model="archivo"
              prepend-icon="attach_file"
              :readonly="true"
            ></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="image"
              @change="onFilePicked"
              id="filePDF"
            />
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="success" @click="guardarFactoresExcel()" dark>
            <v-icon class="mr-1">done_all</v-icon>Guardar
          </v-btn>
          <v-btn color="grey" @click="verCargaFactores" dark>
            <v-icon class="mr-1">cancel</v-icon>Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMateriales" persistent max-width="1100px">
      <v-card>
        <v-card-title>
          <span class="title" v-if="detalleItem.id > 0"
            >Detalle Material : {{ detalleItem.codigoArticulo }}</span
          >
          <span class="title" v-else>Nuevo Material</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md3 v-if="detalleItem.id > 0">
                <v-text-field
                  label="Id"
                  v-model="detalleItem.id"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md9 v-if="detalleItem.id > 0">&nbsp;</v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  label="Código Material"
                  v-model="detalleItem.codigoArticulo"
                  :readonly="detalleItem.id > 0"
                  counter="50"
                  :rules="[rules.required, rules.largoNombre]"
                  maxlength="50"
                  hint="Max 50 carácteres"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md9>
                <v-text-field
                  label="Descripcion"
                  v-model="detalleItem.descripcion"
                  counter="300"
                  :rules="[rules.required, rules.largo]"
                  maxlength="300"
                  hint="Max 300 carácteres"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  label="Unidad Medida"
                  v-model="detalleItem.unidadMedidaVenta"
                  counter="30"
                  :rules="[rules.required, rules.largoUM]"
                  maxlength="30"
                  hint="Max 30 carácteres"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-currency-field
                  label="Factor Empaque"
                  v-model="detalleItem.factorEmpaque"
                  min="0"
                  :rules="[rules.required]"
                />
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="detalleItem.id > 0">
                <v-checkbox
                  v-model="detalleItem.estadoVigencia"
                  label="Vigente?"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 sm6 md3 v-else>
                &nbsp;
              </v-flex>
              <v-flex xs12 sm6 md3>
                &nbsp;
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="saveDetalleItem()" dark>
            <v-icon class="mr-1">done_all</v-icon>Guardar
          </v-btn>
          <v-btn color="grey" @click="cleanDetalle" dark>
            <v-icon class="mr-1">cancel</v-icon>Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-text>
      <!-- <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar..."
          single-line
          hide-details
          @change="getAllMateriales()"
          @keypress="getAllMateriales()"
          @keyup="getAllMateriales()"
          clearable
        ></v-text-field>
      </v-card-title>-->
      <v-data-table
        :items="detalleFiltroItems"
        :headers="headers"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :loading="loading"
        content-tag="v-layout"
        row
        wrap
        no-results-text
        no-data-text
        rows-per-page-text="Registros por página"
      >
        <v-progress-linear
          v-slot:progress
          color="blue"
          indeterminate
        ></v-progress-linear>
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>
            <!--/*
    x.CodigoArticulo, x.Id, x.Descripcion, CodigoDescripcion = x.CodigoArticulo + " - " + x.Descripcion, x.UnidadMedidaVenta, x.FactorEmpaque 
    
    */ -->

            {{ props.item.codigoArticulo }}
          </td>

          <td>{{ props.item.descripcion }}</td>
          <td>{{ props.item.unidadMedidaVenta }}</td>
          <td>{{ props.item.factorEmpaque }}</td>
          <td>
            <v-btn
              :color="calculaStatus(props.item.estadoVigencia)"
              small
              dark
              @click="desactivar(props.item)"
            >
              {{ showVigencia(props.item.estadoVigencia) }}
            </v-btn>
          </td>

          <td class="right layout">
            <v-btn
              color="primary"
              fab
              small
              dark
              @click="verDetalle(props.item)"
              slot="activator"
              class="pr-0 mr-0"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="pageText" slot-scope="props"
          >Registros {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}</template
        >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import OrdenCompraService from "@/services/OrdenCompraService";
import FileService from "@/services/FileService";
import Loader from "@/components/Loader";
import moment from "moment";
//import FiltrosService from "@/services/FiltrosService";
import VWidget from "@/components/VWidget";
import AppEvents from "@/eventBus";

export default {
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: "",
    },
    rules: {
      required: (value) => !!value || "campo obligatorio.",
      largoNombre: (v) => !v || v.length <= 50 || "Max 50 carácteres",
      largo: (v) => !v || v.length <= 300 || "Max 300 carácteres",
      largoUM: (v) => !v || v.length <= 30 || "Max 30 carácteres",
      filtro: (value) => {
        //const pattern = /[^a-zA-Z0-9\s\\*\(\)\|]+/;
        const pattern = /[a-zA-Z0-9*()"\s]$/; ///[a-zA-Z0-9!@#$%^*_|]/;
        if (!value || value.trim().length > 0) {
          return pattern.test(value) || "filtro con formato incorrecto.";
        }
      },
    },
    dialogMateriales: false,
    dialogUpload: false,
    archivo: "",
    /*
    x.CodigoArticulo, x.Id, x.Descripcion, CodigoDescripcion = x.CodigoArticulo + " - " + x.Descripcion, x.UnidadMedidaVenta, x.FactorEmpaque 
    
    */
    detalleItemDefault: {
      id: 0,
      codigoArticulo: null,
      descripcion: null,
      unidadMedidaVenta: null,
      factorEmpaque: null,
      estadoVigencia: true,
    },
    detalleItem: {
      id: 0,
      codigoArticulo: null,
      descripcion: null,
      unidadMedidaVenta: null,
      factorEmpaque: null,
      estadoVigencia: true,
    },
    dialog: false,
    resolve: null,
    search: "",
    reject: null,
    message: null,
    title: null,
    loading: false,
    rowsPerPageItems: [5, 10, 20],
    pagination: {
      page: 1,
      rowsPerPage: 5,
      sortBy: "id",
      descending: true,
    },
    totalItems: 0,
    options: {
      color: "primary",
      width: 290,
      titulo: "",
      filtro: 0,
      cliente: 0,
    },
    /*
    x.CodigoArticulo, x.Id, x.Descripcion, CodigoDescripcion = x.CodigoArticulo + " - " + x.Descripcion, x.UnidadMedidaVenta, x.FactorEmpaque 
    
    */
    headers: [
      {
        text: "Id",
        align: "left",
        sortable: true,
        value: "id",
        width: "5%",
      },
      {
        text: "Código",
        align: "left",
        sortable: true,
        value: "codigoArticulo",
        width: "10%",
      },
      {
        text: "Descripcion",
        align: "left",
        sortable: true,
        width: "40%",
        value: "descripcion",
      },
      {
        text: "Unidad Medida",
        align: "left",
        sortable: true,
        value: "unidadMedidaVenta",
      },
      {
        text: "Factor Empaque",
        align: "left",
        sortable: true,
        value: "factorEmpaque",
      },
      {
        text: "Estado Vigencia",
        align: "left",
        sortable: true,
        value: "estadoVigencia",
      },
    ],
  }),

  methods: {
       async getMaterialesExcel() {      

        this.loading = true;        
        const response = await OrdenCompraService.getMaterialesExcel(
        );
        this.loading = false;
     
    },
    async getAllMateriales() {
      let paging = this.pagination;
      let sort = paging.sortBy === null ? "id" : paging.sortBy;
      let direction =
        paging.descending === null
          ? " desc"
          : paging.descending === true
          ? " desc"
          : " asc";
      sort = sort + direction;
      let paginacion =
        "sort=" +
        sort +
        "&page=" +
        paging.page +
        "&pageSize=" +
        paging.rowsPerPage;

      debugger;
      this.loading = true;
      var busqueda = this.search == null ? "" : this.search;
      const response = await OrdenCompraService.getAllMateriales(
        paginacion,
        busqueda
      )
        .then((r) => {
          debugger;
          this.detalleFiltroItems = r.data.data;
          this.totalItems = r.data.totalCount;
          this.loading = false;
        })
        .catch((r) => {
          console.log(r.response);
        });
    },
    guardarFactoresExcel() {
      let input = document.getElementById("filePDF");
      let files = input.files;
      var FileServiceTMp = new FileService();

      if (files != null && files.length > 0) {
        FileServiceTMp.get(files[0])
          .then((file) => {
            this.loading = true;
            debugger;
            OrdenCompraService.createMaterialesExcel({
              File: file,
              Model: "FileUpload",
            })
              .then((r2) => {
                this.loading = false;
                this.verCargaFactores();
                this.getAllMateriales();
                this.snackbar = {
                  show: true,
                  color: "green",
                  text: "Materiales actualizados con éxito",
                  timeout: 3000,
                };
              })
              .catch((r2) => {
                  debugger;
                this.loading = false;
                console.log(r2.response.data);
                this.snackbar = {
                  show: true,
                  color: "red",
                  text: r2.response.data,
                  timeout: 3000,
                };
              });
          })
          .catch((r1) => {
            console.log(r1);
          });
      }
    },
    verCargaFactores() {
      this.removeFile();
      this.dialogUpload = !this.dialogUpload;
    },
    removeFile() {
      document.getElementById("filePDF").value = "";
      this.archivo = "";
    },
    openFileDialog() {
      document.getElementById("file-upload").click();
    },
    onFileChange(e) {
      let self = this;
      let files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          self.formData.append("file", files[i], files[i].name);
        }
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      debugger;
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.archivo = files[0].name;
        if (this.archivo.lastIndexOf(".") <= 0) {
          return;
        }
      } else {
        this.archivo = "";
      }
    },
    showVigencia(vigencia) {
      return vigencia === true ? "Vigente" : "No Vigente";
    },
    calculaStatus(vigencia) {
      return vigencia === true ? "green" : "red";
    },
    irLicitacion(item) {
      this.$router.push({
        name: "LicitacionDetalle",
        params: { codigo: item.codigoExterno },
      });
    },

    async desactivar(item) {
      this.$refs.confirm
        .open(
          "Desactivar material " + item.codigoArticulo,
          "Desea " +
            (!item.estadoVigencia === true ? "Activar" : "Desactivar") +
            " el material " +
            item.codigoArticulo +
            "  ?",
          {
            color: !item.estadoVigencia === true ? "green" : "red",
            width: 500,
          }
        )
        .then((confirm) => {
          if (confirm) {
            this.loading = true;
            let materialDto = {
              id: item.id,
              codigoArticulo: item.codigoArticulo,
              descripcion: item.descripcion,
              unidadMedidaVenta: item.unidadMedidaVenta,
              estadoVigencia: !item.estadoVigencia,
              factorEmpaque: item.factorEmpaque,
            };
            const response = OrdenCompraService.updateMaterial(materialDto)
              .then((r) => {
                this.loading = false;
                this.getAllMateriales();
                this.snackbar = {
                  show: true,
                  color: "green",
                  text: "Material actualizado con éxito.",
                };
              })
              .catch((r) => {
                this.loading = false;
                console.log(r.response);
              });
          }
        });
    },
    async saveDetalleItem() {
      this.$refs.confirm
        .open(
          (!this.detalleItem.id === 0 ? "Crear " : "Actualizar ") +
            "material " +
            this.detalleItem.codigoArticulo,
          "Desea " +
            (this.detalleItem.id === 0 ? "Crear" : "Actualizar") +
            " el material " +
            this.detalleItem.codigoArticulo +
            "  ?",
          {
            color: "green",
            width: 500,
          }
        )
        .then((confirm) => {
          if (confirm) {
            this.loading = true;
            let materialDto = {
              id: this.detalleItem.id,
              codigoArticulo: this.detalleItem.codigoArticulo,
              descripcion: this.detalleItem.descripcion,
              unidadMedidaVenta: this.detalleItem.unidadMedidaVenta,
              estadoVigencia: this.detalleItem.estadoVigencia,
              factorEmpaque: this.detalleItem.factorEmpaque,
            };
            if(this.detalleItem.id === 0 )
            {
                const response = OrdenCompraService.createMaterial(materialDto)
              .then((r) => {
                this.loading = false;
                this.cleanDetalle();
                this.getAllMateriales();
                this.snackbar = {
                  show: true,
                  color: "green",
                  text:
                    "Material " +
                    (!this.detalleItem.id === 0 ? "creado " : "actualizado ") +
                    " con éxito.",
                };
              })
              .catch((r) => {
                this.loading = false;
                console.log(r.response);
                 this.snackbar = {
                  show: true,
                  color: "red",
                  text: r.response.data.mensaje,
                };
              });
            }
            else
            {
                const response = OrdenCompraService.updateMaterial(materialDto)
              .then((r) => {
                this.loading = false;
                this.cleanDetalle();
                this.getAllMateriales();
                this.snackbar = {
                  show: true,
                  color: "green",
                  text:
                    "Material " +
                    (!this.detalleItem.id === 0 ? "creado " : "actualizado ") +
                    " con éxito.",
                };
              })
              .catch((r) => {
                this.loading = false;
                console.log(r.response);
                 this.snackbar = {
                  show: true,
                  color: "red",
                  text: r.response.data.mensaje,
                };
              });
            }
            
          }
        });
    },
    cleanDetalle() {
      this.dialogMateriales = false;
      this.detalleItem = Object.assign({}, this.detalleItemDefault);
    },
    async verDetalle(items) {
     
      this.detalleItem = Object.assign({}, items);
      this.dialogMateriales = true;
      
    },
     async createNewMaterial() {
      
      this.detalleItem = Object.assign({}, this.detalleItemDefault);
      this.dialogMateriales = true;
    },
  },
  mounted() {},
  watch: {
    pagination: {
      handler() {
        this.getAllMateriales();
      },
      deep: true,
    },
    dialog: {
      handler: function(val, oldVal) {
        debugger;
        if (!val) {
          setTimeout(function() {}, 500);
        }
      },
      deep: true,
    },
  },
};
</script>
